<template>
  <b-overlay :show="loading">
    <SuccessfulBiddersFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <div class="text-left mb-2 d-flex justify-content-start align-items-center">
      <b-button
        class="ml-4 badge-glow"
        variant="primary"
        @click="newBidder()"
        size="sm"
        v-has-permission="'ED211'"
        data-cy="add"
      >
        <span class="align-middle">Nuevo</span>
      </b-button>
      <b-button
        class="ml-4 badge-glow"
        variant="warning"
        size="sm"
        data-cy="download"
        @click="downloadList()"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-3"
          data-cy="download"
        />
        <span class="align-middle">Descargar</span>
      </b-button>
    </div>
    <SuccessfulBiddersHeader/>
    <div
      class="force-render"
      :key="forceRender"
    >
      <SuccessfulBidderRow
        :key="bidder.adjudicatarioId"
        v-for="bidder in filteredSuccessfulBidders"
        :bidder="bidder"
        :reloadList="reloadList"
        :select-bidder="selectSuccessfulBidder"
        v-on:bidder-save="handleBidderSave"
      />
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando <select
          v-model="rowspp"
          @change="fetchSuccessfulBidders()"
        >
          <option
            value="10"
            selected="selected"
          >
            10
          </option>
          <option value="15">15</option>
          <option value="30">30</option>
          <option value="50">50</option>
        </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <SuccessfulBiddersPagination
          :show="filteredSuccessfulBidders.length"
          v-model="page"
        />
      </div>
    </div>
    <b-modal
      title="Nuevo adjudicatario"
      no-close-on-backdrop
      ref="newBidder"
      size="lg"
      hide-footer
    >
      <BidderForm v-on:bidder-save="handleBidderSave"/>
    </b-modal>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import SuccessfulBidderRow from '@/febos/aduanas/successfulBidder/views/components/SuccessfulBidderRow';
import SuccessfulBiddersHeader from '@/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersHeader';
import SuccessfulBiddersFilters from '@/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersFilters';
import BidderForm from '@/febos/aduanas/successfulBidder/views/components/BidderForm';
import SuccessfulBiddersPagination from '@/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersPagination';
import { getSuccessfulBidders, selectSuccessfulBidderState } from '@/febos/aduanas/successfulBidder/store/actions';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { pagination, successfulBidders } from '@/febos/aduanas/successfulBidder/store/getters';
import { successfulBiddersList } from '@/febos/servicios/api/aduanas/successfulBidders';

export default {
  components: {
    BidderForm,
    SuccessfulBidderRow,
    SuccessfulBiddersHeader,
    SuccessfulBiddersFilters,
    SuccessfulBiddersPagination
  },
  data() {
    return {
      loading: false,
      selectedSuccessfulBidder: {},
      filters: '',
      textSearch: '',
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      searchParam: false,
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchSuccessfulBidders();
    }
  },
  computed: {
    ...mapGetters('successfulBidders', {
      successfulBidders: successfulBidders.name,
      pagination: pagination.name
    }),
    filteredSuccessfulBidders() {
      return this.successfulBidders;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('successfulBidders', {
      getSuccessfulBidders: getSuccessfulBidders.name,
      selectSuccessfulBidderState: selectSuccessfulBidderState.name
    }),
    selectBidder(bidder) {
      this.selectedSuccessfulBidder = bidder;
      this.selectSuccessfulBidderState(bidder.adjudicatarioId);
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('adjudicatarioId')) {
          return this.$route.query.filters;
        }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    clearFilters() {
      removeSearchParams(['filters']);
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchSuccessfulBidders();
        }
      }
    },
    async downloadList() {
      const filters = this.getFilters();
      const { page } = this;
      this.loading = true;
      try {
        const { data } = await successfulBiddersList({
          items: this.rowspp,
          page,
          filters,
          format: 'csv'
        });
        window.open(data.url, '_blank');
      } finally {
        this.loading = false;
      }
    },
    fetchSuccessfulBidders() {
      const filters = this.getFilters();
      const { page } = this;
      updateSearchParams({ page, filters });
      this.loading = true;
      try {
        this.getSuccessfulBidders({
          items: this.rowspp,
          page,
          ...(filters !== '' && { filters })
        });
      } finally {
        this.loading = false;
      }
    },
    selectSuccessfulBidder(bidder) {
      this.selectedSuccessfulBidder = bidder;
      this.selectSuccessfulBidderState(bidder.adjudicatarioId);
    },
    newBidder() {
      this.$refs.newBidder.show();
    },
    handleBidderSave() {
      this.$refs.newBidder.hide();
      const message = 'Adjudicatario guardado exitosamente';
      this.$bvToast.toast(
        message,
        {
          title: 'Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.loading = true;
      setTimeout(() => {
        this.fetchSuccessfulBidders();
      }, 2000);
    },
    reloadList() {
      this.fetchSuccessfulBidders();
    }
  },
  created() {
    this.closeModal();
    this.selectSuccessfulBidderState('');
  },
  mounted() {
    this.fetchSuccessfulBidders();
  }
};
</script>
